// extracted by mini-css-extract-plugin
export default {"feedbackModal":"FeedbackModal_feedbackModal__Qbat8","modal":"FeedbackModal_modal__1ovO4"};